import { Helmet } from 'react-helmet-async';
import {
    HomeButton,
    NotFoundContainer,
    Subtitle,
    Title
} from './styles/NotFoundPage.styles';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 — Page Not Found | Fussaki Spearfishing Charters</title>
        <meta name="description" content="The page you're looking for doesn't exist. Head back to Fussaki Spearfishing Charters and explore our charters, book a trip, or contact Captain Christos." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <NotFoundContainer>
        <Title>404 - Page Not Found</Title>
        <Subtitle>
          Looks like you've ventured into uncharted waters! The page you're looking for doesn't exist or may have been moved.
        </Subtitle>
        <HomeButton to="/">Back to Home</HomeButton>
      </NotFoundContainer>
    </>
  );
};

export default NotFoundPage;
